import { render } from "./ManageProperties.vue?vue&type=template&id=608fac3c&scoped=true"
import script from "./ManageProperties.vue?vue&type=script&lang=js"
export * from "./ManageProperties.vue?vue&type=script&lang=js"

import "./ManageProperties.vue?vue&type=style&index=0&id=608fac3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608fac3c"]])

export default __exports__